import { createApp, h } 			 from 'vue'
import { InertiaProgress } 			 from '@inertiajs/progress'
import { createInertiaApp, usePage } from '@inertiajs/inertia-vue3'
import PrimeVue 					 from 'primevue/config'
import FloatingVue 					 from 'floating-vue'

import 'floating-vue/dist/style.css'

InertiaProgress.init()

createInertiaApp({
	resolve: name => require(`./Pages/${name}`),
	title: title => title ? `${title} - Pfizershop` : 'Pfizershop',
	setup({el, App, props, plugin}) {
		createApp({render: () => h(App, props)})
			.use(plugin)
			.use(PrimeVue)
			.use(FloatingVue)
			.mixin({
				methods: {
					'__'(key, replace = {}) {
						let language = usePage().props.value.language
						let translation = language[key] ? language[key] : key

						Object.keys(replace).forEach(function (k) {
							translation = translation.replace(':' + k, replace[k])
						})

						return translation
					}
			}
		})
		.mount(el)
	}
})
